import { render, staticRenderFns } from "./home-type4.vue?vue&type=template&id=aad4ce5c&scoped=true"
import script from "./home-type4.vue?vue&type=script&lang=js"
export * from "./home-type4.vue?vue&type=script&lang=js"
import style0 from "./home-type4.vue?vue&type=style&index=0&id=aad4ce5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad4ce5c",
  null
  
)

export default component.exports